import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { TranslateModule } from '@ngx-translate/core';
import { AddApiUrlBeforePathPipe } from 'src/app/core/pipes/add-api-url-before-path.pipe';
import { AudioControllerModule } from 'src/app/shared/components/audio-controller/audio-controller.module';
import { ListGroupItemModule } from 'src/app/shared/global/list-group-item/list-group-item.module';
import { ModalTitleComponent } from 'src/app/shared/global/modal-title/modal-title.component';

@Component({
    selector: 'app-voice-sms-detail-modal',
    templateUrl: './voice-sms-detail-modal.component.html',
    imports: [
        CommonModule,
        ModalTitleComponent,
        TranslateModule,
        AudioControllerModule,
        AddApiUrlBeforePathPipe,
        ListGroupItemModule,
    ]
})
export class VoiceSmsDetailModalComponent {
  //#region Properties
  smsText: string;
  model: any;

  //#endregion

  constructor(
    private dialogRef: MatDialogRef<VoiceSmsDetailModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data.model) {
      this.smsText = data.model?.smsText;
      this.model = data?.model?.content;
    }
  }

  onClose() {
    this.dialogRef.close();
  }
}
